import { Component, Input, Output, EventEmitter, ViewEncapsulation, OnInit } from '@angular/core';
import { ClaimsService, MenuService } from '../core/services';

@Component({
    selector: 'account-bar',
    templateUrl: 'account-bar.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AccountBarComponent implements OnInit {
    @Input('visible')
    public visible: boolean;

    @Input()
    lastUpdate: Date = null;

    @Input('userName')
    public userName: string;

    @Output()
    public click: EventEmitter<any> = new EventEmitter<Event>();;

    @Output()
    public toggleAccountBarClick: EventEmitter<any> = new EventEmitter<Event>();

    @Output()
    public logout: EventEmitter<any> = new EventEmitter<Event>();

    constructor(private claimsService: ClaimsService, private menuService: MenuService) {
    }

    ngOnInit(){
        this.visible = this.visible || false;
        this.userName = this.userName || '';
    }

    public onClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        let route = this.menuService.getDefaultPageUrl(this.claimsService.getUserTypeId());
        this.click.emit({ event, route });
    }

    public onToggleAccountBarClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        this.toggleAccountBarClick.emit({ event });
    }

    public onLogout(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        this.logout.emit();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/account-bar.component.ts